//Generated File 
export default class TechnicianAppointmentStatus{
	static readonly Booked = `Booked`;
	static readonly Cancelled = `Cancelled`;
	static readonly Executed = `Executed`;
	static readonly NoShow = `NoShow`;
	static readonly Rescheduled = `Rescheduled`;
}
